import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Loss Prevention System',
    id: 'EObMrM',
    description: 'Title for system card',
  },
  description: {
    defaultMessage: 'Enable or disable the entire loss prevention fraud detection system.',
    id: '8KHOir',
    description: 'Description for system card',
  },
  warningBannerTitle: {
    defaultMessage: 'Loss Prevention Disabled',
    id: 'uRTNr2',
    description: 'Title for warning banner when system is disabled',
  },
  warningBannerMessage: {
    defaultMessage: 'All fraud detection rules are currently disabled. Enable the system to protect your business from fraudulent orders.',
    id: '9lJK+l',
    description: 'Warning message when system is disabled',
  },
});
